import { useCallback } from 'react'

import { useProductRefreshPreviewContext } from './productRefreshPreviewContext'

export const useProductRefreshPreviewToggle = () => {
  const { override, setOverride } = useProductRefreshPreviewContext()
  const checked = override === true
  const onChange = useCallback((e) => {
    setOverride(e.target.checked)
  }, [setOverride])

  return { checked, onChange }
}
